import { Circle, Container } from './styles';

interface TipoRelatorioProps {
  circleColor: 'yellow' | 'green' | 'brown';
  text: string;
}

export const TipoRelatorio = ({ circleColor, text }: TipoRelatorioProps) => {
  return (
    <Container>
      <Circle circleColor={circleColor} />

      <p>{text}</p>
    </Container>
  );
};
